import { UserModule } from './modules/user/user.module';
import { NewsfeedModule } from './modules/newsfeed/newsfeed.module';
import { FileModule } from './modules/file/file.module';
import { ChapterModule } from './modules/chapter/chapter.module';

export const FEATURE_MODULES = [UserModule, NewsfeedModule, FileModule, ChapterModule];
